/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetReportPlansCsvListRequest
 */
export interface RequestGetReportPlansCsvListRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestGetReportPlansCsvListRequest
     */
    shippedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestGetReportPlansCsvListRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestGetReportPlansCsvListRequest interface.
 */
export function instanceOfRequestGetReportPlansCsvListRequest(value: object): value is RequestGetReportPlansCsvListRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestGetReportPlansCsvListRequestFromJSON(json: any): RequestGetReportPlansCsvListRequest {
    return RequestGetReportPlansCsvListRequestFromJSONTyped(json, false);
}

export function RequestGetReportPlansCsvListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetReportPlansCsvListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestGetReportPlansCsvListRequestToJSON(json: any): RequestGetReportPlansCsvListRequest {
    return RequestGetReportPlansCsvListRequestToJSONTyped(json, false);
}

export function RequestGetReportPlansCsvListRequestToJSONTyped(value?: RequestGetReportPlansCsvListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipped_date': value['shippedDate'],
        'tenant_id': value['tenantId'],
    };
}

